// src/services/vehicleService.js
import axios from 'axios';
import { toast } from 'react-toastify';

const apiUrl = process.env.REACT_APP_API_URL;

export const getVehicles = async () => {
  try {
    const { data } = await axios.get(apiUrl);
    return data;
  } catch (error) {
    toast.error("❌ Failed to fetch vehicles");
    throw error;
  }
};

export const addVehicle = async (vehicle) => {
  const formData = new FormData();

  // Append values
  formData.append("number", vehicle.number);
  formData.append("driverPhone", vehicle.driverPhone);
  formData.append("ownerName", vehicle.ownerName);

  // Expiry dates
  formData.append("taxExpiry", vehicle.taxExpiry);
  formData.append("fitnessExpiry", vehicle.fitnessExpiry);
  formData.append("insuranceExpiry", vehicle.insuranceExpiry);
  formData.append("pollutionExpiry", vehicle.pollutionExpiry);
  formData.append("permitExpiry", vehicle.permitExpiry);

  // Files
  if (vehicle.taxFile) formData.append("taxFile", vehicle.taxFile);
  if (vehicle.fitnessFile) formData.append("fitnessFile", vehicle.fitnessFile);
  if (vehicle.insuranceFile) formData.append("insuranceFile", vehicle.insuranceFile);
  if (vehicle.pollutionFile) formData.append("pollutionFile", vehicle.pollutionFile);
  if (vehicle.permitFile) formData.append("permitFile", vehicle.permitFile);

  try {
    const { data } = await axios.post(apiUrl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    toast.success("✅ Vehicle saved successfully!");
    return data;
  } catch (error) {
    toast.error("❌ Failed to save vehicle");
    throw error;
  }
};

export const updateVehicle = async (vehicle) => {
  const formData = new FormData();

  // Required fields
  formData.append("number", vehicle.number);
  if (vehicle.driverPhone) formData.append("driverPhone", vehicle.driverPhone);
  if (vehicle.ownerName) formData.append("ownerName", vehicle.ownerName);

  // Expiry dates
  if (vehicle.taxExpiry) formData.append("taxExpiry", vehicle.taxExpiry);
  if (vehicle.fitnessExpiry) formData.append("fitnessExpiry", vehicle.fitnessExpiry);
  if (vehicle.insuranceExpiry) formData.append("insuranceExpiry", vehicle.insuranceExpiry);
  if (vehicle.pollutionExpiry) formData.append("pollutionExpiry", vehicle.pollutionExpiry);
  if (vehicle.permitExpiry) formData.append("permitExpiry", vehicle.permitExpiry);

  // Files
  if (vehicle.taxFile) formData.append("taxFile", vehicle.taxFile);
  if (vehicle.fitnessFile) formData.append("fitnessFile", vehicle.fitnessFile);
  if (vehicle.insuranceFile) formData.append("insuranceFile", vehicle.insuranceFile);
  if (vehicle.pollutionFile) formData.append("pollutionFile", vehicle.pollutionFile);
  if (vehicle.permitFile) formData.append("permitFile", vehicle.permitFile);

  try {
    const { data } = await axios.post(`${apiUrl}/update/${vehicle.number}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    toast.success("✅ Vehicle updated successfully!");
    return data;
  } catch (error) {
    toast.error("❌ Failed to update vehicle");
    throw error;
  }
};

export const deleteVehicle = async (number) => {
  try {
    const { data } = await axios.post(`${apiUrl}/delete/${number}`);
    toast.info("🗑️ Vehicle deleted successfully!");
    return data;
  } catch (error) {
    toast.error("❌ Failed to delete vehicle");
    throw error;
  }
};
